// BFSG
import useBrandUrl from 'hooks/account/useBrandUrl'
import useTranslations from 'hooks/useTranslations'
import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import Link from 'theme/atoms/Link'
import { Product } from 'utils/productListFetcher/types'

type Props = {
  product: {
    attributes: Product['attributes']
    brand?: Product['brand']
  }
  brandPath: string
  'data-cy-state'?: string
}

export default function Brand(props: Props) {
  const t = useTranslations<'molecules-HighlightProduct'>()
  const brandUrl = useBrandUrl(props.product.brand ?? '', props.brandPath)

  return (
    <Wrapper className="Brand" data-cy-state={props['data-cy-state']}>
      {props.product.attributes.BRAND &&
        props.product.attributes.BRAND.values.map((brand, i) => {
          return (
            <Link
              to={brandUrl}
              key={i}
              className="brand"
              data-cy-handle="brand-link"
              aria-label={t.asText(false, 'BFSG_to_brand_page', {
                BRAND: brand.value || ''
              })}
            >
              <div className="label">{brand?.value}</div>
            </Link>
          )
        })}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  > .brand {
    ${theme.ty('r-base')}
    margin-bottom: ${theme.spacing('xs')};
    display: flex;

    > .logo {
      margin-right: ${theme.spacing('xs')};
      margin-top: 0.125rem;
      img {
        max-height: 1.1875rem;
      }
    }
  }
`
